import { useState } from 'react';
import Chooser from 'components/common/Chooser/Chooser';

/**
 * Examples of Chooser.
 */

function ChooserExamplePage(): JSX.Element {
  const [sourceItems, setSourceItems] = useState<string[]>(['Item 1', 'Item 2', 'Item 3']);
  const [targetItems, setTargetItems] = useState<string[]>([]);

  return (
    <section id="chooser" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Chooser</h1>
      <div className="ExamplesPage__Description">
        This controlled component allows the user to choose items from a list. It does that by presenting two lists to
        the user, a list of available items on the left, and a list of chosen items on the right, with buttons to
        shuffle items back and forth.
      </div>
      <div className="ExamplesPage__ExampleRow">
        <Chooser
          sourceItems={sourceItems}
          targetItems={targetItems}
          onSourceChange={setSourceItems}
          onTargetChange={setTargetItems}
        />
      </div>
    </section>
  );
}

export default ChooserExamplePage;
